import React, { useEffect, useRef, useState } from 'react';
import './application.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import classNames from 'classnames';
import {
  calculatedViewMode,
  getFilterData, getJSONFromString,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  applicationFieldsValidation,
  archiveApplication, groupSignApplication,
  importApplication, loadApplicationById, loadApplicationByIdClear,
  loadApplicationList, signApplication, unarchiveApplication, unAssignApplicationById,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getApplicationData } from '../reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import ApplicationForm from './ApplicationForm';
import ApplicationView from './ApplicationView';
import {
  APPLICATION_STATUS,
  PROCEDURE_CARRIER_TYPES, PROCEDURE_SZLT_TYPES, PROCEDURE_VEHICLE_TYPES,
} from '../../../configs';
import ApplicationSelectProcedure from './ApplicationSelectProcedure';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { showSignPopup } from '../../System/actions';
import { FORBIDDEN } from '../../../configs/serverStatusCodes';
import FilterForm from './FilterForm';
import {
  applicationAdditionalColumns,
  applicationColumns,
} from './applicationColumns';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import DropdownList from '../../../components/base/Dropdown/DropdownList';
import CheckBoxInput from '../../../components/fields/CheckBoxInput/CheckBoxInput';
import ExportInterface from '../../System/components/ExportInterface';
import RegistryImport from '../../RegionRegistry/RegistryImport';

export default function ApplicationPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [showSelectProcedure, setShowSelectProcedure] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isAllPageRowsSelected, setIsAllPageRowsSelected] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isAssign, setIsAssign] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const procedureText = searchParams.get('procedures');
  const [showImport, setShowImport] = useState(false);
  const [prevProcedures, sePrevProcedures] = useState(procedureText);
  const search = searchParams.get('search');
  const number = searchParams.get('number');
  const [selected, setSelected] = useState([]);
  const created_at_from = searchParams.get('created_at_from');
  const created_at_to = searchParams.get('created_at_to');
  const application_id = searchParams.get('application_id');
  const isNew = searchParams.get('new');
  let pageName = 'application';
  const procedures = getJSONFromString(procedureText) || [];
  if (procedures && procedures.length) { pageName = `application-${procedures.join(',')}`; }
  const filterName = `${pageName}-filter`;
  const inVehicle = procedures.some(i => PROCEDURE_VEHICLE_TYPES.includes(i));
  const inSzlt = procedures.some(i => PROCEDURE_SZLT_TYPES.includes(i));
  const inCarrier = procedures.some(i => PROCEDURE_CARRIER_TYPES.includes(i));

  const store = useStore();
  const {
    loadingList,
    list = [],
    listMeta = {},
    loadingCurrentApplication,
    currentApplication,
    loadingFieldsValidation,
    fieldsValidation,
    loadingImport,
  } = useSelector(getApplicationData);

  const { formatMessage } = useIntl();

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    // status: [
    //   APPLICATION_STATUS.NEW,
    //   APPLICATION_STATUS.CHECKING,
    //   APPLICATION_STATUS.SUSPENDED,
    //   APPLICATION_STATUS.UPDATED,
    //   APPLICATION_STATUS.REVIEW,
    // ],
    // created_at_from: defaultDate[0],
    // created_at_to: defaultDate[1],
    procedures,
    // view_mode: 2,
  };
  const [selectedRow, setSelectedRow] = useState(null);
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  let title = '';
  let titleFull = '';
  if (inVehicle && !inSzlt && !inCarrier) { title = 'Журнал ЛТ'; }
  if (!inVehicle && inSzlt && !inCarrier) { title = 'Журнал СЗЛТ'; }
  if (!inVehicle && !inSzlt && inCarrier) { title = 'Журнал перевозчиков'; }
  if (procedures.length === 1) {
    titleFull = formatMessage({ id: `menu.application.${procedures[0]}` });
  }

  const handleSetUrlParams = params => {
    const result = Object.keys(params).reduce((acc, c) => {
      if (params[c]) {
        acc[c] = params[c];
      }
      return acc;
    }, {});
    setSearchParams(result);
  };

  const handleAddUrlParams = params => {
    const res = {};
    for (const entry of searchParams.entries()) {
      const [key, value] = entry;
      res[key] = value;
    }
    const keys = Object.keys(params);
    for (const key of keys) {
      res[key] = params[key];
    }
    setSearchParams(res);
  };
  const handleRemoveUrlParams = (names = []) => {
    const res = {};
    for (const entry of searchParams.entries()) {
      const [key, value] = entry;
      if (!names.includes(key)) {
        res[key] = value;
      }
    }
    setSearchParams(res);
  };

  const loadApplication = id => {
    if (application_id || id) {
      dispatch(loadApplicationById(application_id || id))
        .then(() => {
          dispatch(applicationFieldsValidation({ id: application_id || id })).catch(responseLogWithNotification);
          setShowView(true);
        })
        .catch(response => {
          handleSetUrlParams({ procedures: procedureText });
          if (response && response.status === FORBIDDEN) {
            return errorNotification('Загрузка заявления', 'Заявление обрабатывается другим пользователем');
          }
          errorNotification('Загрузка заявления', getResponseError(response));
        });
    }
  };

  const unAssign = id => {
    setIsAssign(false);
    return dispatch(unAssignApplicationById(id))
      .catch(response => {
        errorNotification('Загрузка заявления', getResponseError(response));
      });
  };

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].listMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData },
    };
    const p1 = dispatch(loadApplicationList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(loadApplication, [application_id]);
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  useEffect(() => setShowSelectProcedure(!!isNew), [isNew]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem(filterName, JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch, filterName]);
  useEffect(() => {
    const d = getFilterData(filterName, defaultFilterValues);
    if (d.search && d.search !== search) {
      handleAddUrlParams({ search: d.search });
    }
    reset(d);
  }, [filterName]);
  useEffect(() => setValue('search', search), [search]);
  useEffect(() => setValue('number', number), [number]);
  useEffect(() => {
    setValue('procedures', getJSONFromString(procedureText) || []);
    if (prevProcedures !== procedureText) {
      sePrevProcedures(procedureText);
      handleClose();
    }
  }, [procedureText]);

  const handleSelectRow = item => {
    let select = item;
    if (selectedRow && selectedRow.id === item.id) {
      select = null;
    }
    setSelectedRow(select);
  };

  const handleCreate = () => {
    setShowSelectProcedure(true);
    setIsEdit(false);
    setShowView(false);
    setIsAssign(false);
    clearCurrentState();
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    setIsAssign(false);
    handleSetUrlParams({ procedures: procedureText, search, application_id: item.id });
    event.preventDefault();
    event.stopPropagation();
  };

  const handleCloseForm = () => {
    if (currentApplication && isEdit) {
      setIsEdit(false);
      setShowForm(false);
      setShowView(true);
      setIsAssign(false);
      handleSetUrlParams({ procedures: procedureText, search, application_id: currentApplication.id });
      return;
    }
    handleClose();
  };

  const handleImport = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importApplication(data))
      .then(() => { successNotification('Импорт заявлений', 'Процесс импорта прошел успешно'); loadData(); })
      .catch(response => errorNotification('Импорт заявлений', getResponseError(response)));
    setShowImport(false);
  };

  const checkBoxColumnFormatter = (_, item) => {
    const check = selected.includes(item.id);
    return (
      <div className="bordered-checkbox" onClick={e => { setSelected(check ? selected.filter(e => e !== item.id) : [...selected, item.id]); e.stopPropagation(); }}>
        <CheckBoxInput
          inputProps={{
            value: check,
          }}
        />
      </div>
    );
  };

  const checkBoxHeaderFormatter = () => {
    const isAllRowsSelected = selected?.length === list?.length && selected?.length && list?.length && !isAllPageRowsSelected;
    return (
      <div
        className="bordered-checkbox"
        onClick={() => {
          if (selected?.length >= list?.length) {
            if (isAllPageRowsSelected) {
              setSelected([]);
            }
            setIsAllPageRowsSelected(!isAllPageRowsSelected);
            return;
          }
          setSelected(selected.length < list?.length ? list.map(e => e.id) : []);
        }}
      >
        <CheckBoxInput
          className={classNames({ 'some-child': selected.length && !isAllPageRowsSelected && !isAllRowsSelected }, { 'all-child': isAllPageRowsSelected })}
          inputProps={{
            value: isAllRowsSelected,
          }}
        />
      </div>
    );
  };

  const handleClose = () => {
    setSelectedRow(false);
    setShowForm(false);
    setShowSelectProcedure(false);
    setSearchParams({});
    setShowView(false);
    setShowImport(false);
  };

  const clearCurrentState = () => {
    dispatch(loadApplicationByIdClear()).catch(responseLogWithNotification);
  };

  const handleArchive = item => () => {
    if (!item) {
      return;
    }
    const action = item.archived_at ? unarchiveApplication : archiveApplication;
    dispatch(action(item.id))
      .then(() => {
        loadData();
        successNotification('Отзыв заявления', 'Отзыв заявления прошел успешно');
      })
      .catch(response => errorNotification('Отзыв заявления заявления', getResponseError(response)));
  };

  const handleEdit = item => event => {
    if (!item) {
      return;
    }

    dispatch(applicationFieldsValidation({ id: item.id })).catch(responseLogWithNotification);
    setShowForm(true);
    setIsEdit(true);
    setShowView(false);
    setIsAssign(false);
  };

  const columns = [
    {
      dataField: 'checkBox',
      headerClassName: 'check-box text-center column-relative',
      dataClassName: 'align-middle column-relative text-center justify-content-center',
      formatter: checkBoxColumnFormatter,
      headerFormatter: checkBoxHeaderFormatter,
    },
    ...applicationColumns,
  ];

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleArchive(item)}>
            Отозвать заявление
          </Button>
          <Button
            disabled={item.status !== APPLICATION_STATUS.SIGN_PENDING && item.status !== APPLICATION_STATUS.SIGN_FAILED}
            variant="link"
            className="w-100 more-button"
            onClick={() => handleSign(item)}
          >
            Подписать
          </Button>
          {item?.status === APPLICATION_STATUS.DRAFT ? (
            <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
              Редактировать
            </Button>
          ) : null }
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const handlePackageSign = () => {
    dispatch(showSignPopup())
      .then(cert => {
        dispatch(groupSignApplication({ filter: getValues(), cert, selected }))
          .then(() => {
            setSelected([]);
            loadData();
            successNotification('Пакетное подписание документов', 'Подписание прошло успешно');
          })
          .catch(responseLogWithNotification);
      }).catch(() => {});
  };

  const handleSign = item => {
    dispatch(showSignPopup())
      .then(cert => {
        dispatch(signApplication({ application: item, cert }))
          .then(() => {
            loadData();
            successNotification('Подписание обращения', 'Подписание прошло успешно');

            /*
                    dispatch(editApplicationById({ id: item.id, extra: { is_draft: false }, status: 1 }))
          .then(() => {
            loadData();
            loadApplication();
            successNotification('Подписание обращения', 'Подписание прошло успешно');
          })
          .catch(responseLogWithNotification);
             */
          })
          .catch(responseLogWithNotification);
      }).catch(() => {});
  };

  return (
    <div className="page application-page">
      <Loader loading={loadingList || loadingCurrentApplication || loadingFieldsValidation || loadingImport} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.application' })}{title ? <span className="sub-title-text"> - {title}</span> : ''}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
            inputProps={{
              value: search || getValues('search') || '',
              onChange: e => handleSetUrlParams({ procedures: procedureText, search: e.target.value || '' }),
            }}
          />
          <div className="filter-sep" />
          <DropdownList
            className="ml-3 button-list second"
            label={(
              <>
                <span className="load-button-label-text">Пакетная обработка</span>
                <Icons className="load-icon-arrow" icon="arrow-down" customIcon />
              </>
            )}
            variant="second"
          >
            {/* <Button */}
            {/*  variant="link" */}
            {/*  className="button-alternate menu-button grey-text" */}
            {/*  onClick={handlePackageSign} */}
            {/* > */}
            {/*  Подписать */}
            {/* </Button> */}
            <Button
              variant="link"
              className="button-alternate menu-button grey-text"
            >
              Отозвать
            </Button>
            <Button
              variant="link"
              className="button-alternate menu-button grey-text"
            >
              Удалить
            </Button>
          </DropdownList>
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          <div className="filter-sep" />
          <ExportInterface page="applications" exporter="applications" getValues={getValues} selected={selected} />
          <div className="filter-sep" />
          <Button
            variant="second"
            onClick={() => {
              setShowImport(true);
            }}
          >
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="import"
            />
          </Button>
          <div className="filter-sep" />
          <Button variant="second" onClick={handleCreate}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
          {isOpenFilter
            ? (
              <FilterForm
                control={control}
                onHide={() => {
                  setOpenFilter(false);
                }}
                getValues={getValues}
                reset={reset}
                defaultValues={defaultFilterValues}
                meta={listMeta}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                key={pageName}
                onClickByRow={handleSelectRow}
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                data={list}
                columns={columns}
                additionalColumns={applicationAdditionalColumns}
                name={`${pageName}-list`}
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={listMeta} list={list} handleChangeMeta={loadData} />
        </div>
      </div>
      {showSelectProcedure ? (
        <ApplicationSelectProcedure
          onSelectProcedure={procedure => {
            clearCurrentState();
            setSelectedProcedure(procedure);
            setShowForm(true);
            setShowSelectProcedure(false);
            handleRemoveUrlParams(['new']);
          }}
          onClose={() => {
            handleClose();
            if (isAssign) {
              unAssign(currentApplication.id);
            }
          }}
        />
      ) : null}
      {showForm ? (
        <ApplicationForm
          key={selectedProcedure}
          currentApplication={currentApplication}
          isEdit={isEdit}
          selectedProcedure={selectedProcedure}
          fieldsValidation={fieldsValidation}
          loadData={loadData}
          onCancel={handleCloseForm}
          onClose={handleClose}
          handleSetUrlParams={handleSetUrlParams}
          title={title}
          titleFull={titleFull}
          loadApplication={loadApplication}
          isAssign={isAssign}
        />
      ) : null}
      {showView && currentApplication?.id
        ? (
          <ApplicationView
            loadApplication={loadApplication}
            loadData={loadData}
            unAssign={unAssign}
            isAssign={isAssign}
            onClose={handleClose}
            handleSign={handleSign}
            handleEdit={handleEdit}
            title={title}
            titleFull={titleFull}
          />
        ) : null}
      {showImport ? <RegistryImport title="Импорт заявлений" handleImport={handleImport} onClose={handleClose} /> : null}
    </div>
  );
}
